/**
 * Which saved view the alarm list opens with.
 *
 * Remembered per browser, by choice: the API's `is_default` marks one view per
 * scope (personal, or a shared team view) and is what `GET /views` reports,
 * but an operator who works from several devices may want a different opening
 * view on the phone than on the desk. This store is local to the device and
 * never sent anywhere.
 */
const DEFAULT_VIEW_KEY = 'vam.alarms.defaultView';

export function readDefaultViewId(): string | null {
  try {
    return localStorage.getItem(DEFAULT_VIEW_KEY);
  } catch {
    return null;
  }
}

export function writeDefaultViewId(id: string | null): void {
  try {
    if (id) localStorage.setItem(DEFAULT_VIEW_KEY, id);
    else localStorage.removeItem(DEFAULT_VIEW_KEY);
  } catch {
    /* the default simply does not persist */
  }
}
